import { ALL_CATEGORIES } from './constants.js';
const data = {
    'SPP Live': [],
    'SPP Comments': [],
    Curate: [],
    MBL: [],
    Youbora: ['CMP:analytics'],
    Glimr: ALL_CATEGORIES,
    Braze: ['CMP:marketing'],
    BrandMetrics: ALL_CATEGORIES,
    Sentry: [],
    Datadog: [],
    /**
     * Being investigated. Most likely requires personalisation for any rollout
     * strategy that is based on user details, but naive non-behavioural
     * strategies can be used without consent.
     */
    Unleash: ['CMP:personalisation'],
    Hotjar: ['CMP:analytics'],
    Iterate: ALL_CATEGORIES,
    'Google Analytics': ['CMP:analytics'],
};
export const registry = {
    getConsentCategories: async function (integrationName) {
        // fallback to require all consents to be on the safe side.
        return data[integrationName] ?? ALL_CATEGORIES;
    },
};
